import { PodcastEntity } from '@/graphql/generated/graphql';

export default function isPodcastDone(podcast: PodcastEntity) {
  const userListed = (podcast?.attributes?.listenings?.data?.length || 0) > 0;
  let progress = 0;
  let isDone;

  if (userListed) {
    const linsteningTime = podcast?.attributes?.listenings?.data[0].attributes;
    progress = Math.ceil((linsteningTime?.listeningTime / linsteningTime?.duration) * 100);
    isDone = progress >= 90;
  }

  return { progress, isDone };
}
